import { Box, Button, Spinner, Text, useToast } from "@chakra-ui/react";
import { LockIcon } from "@chakra-ui/icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Ornament, PaletteIcon } from "../components/ui/Icons";

// Страница приглашения: /join/<тег или код>
const JoinPage = () => {
  const { key } = useParams();
  const history = useHistory();
  const toast = useToast();

  const [me] = useState(() => JSON.parse(localStorage.getItem("userInfo")));
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    if (!me) {
      // сначала вход — потом вернёмся к приглашению
      localStorage.setItem("pendingInvite", key);
      history.push("/");
      return;
    }
    axios
      .get(`/api/chat/invite/${key}`, {
        headers: { Authorization: `Bearer ${me.token}` },
      })
      .then(({ data }) => setInfo(data))
      .catch((e) =>
        setError(e.response?.data?.message || "Приглашение не действует")
      );
  }, [me, key, history]);

  const join = async () => {
    try {
      setJoining(true);
      await axios.put(
        "/api/chat/join",
        { key },
        { headers: { Authorization: `Bearer ${me.token}` } }
      );
      toast({
        title: `Вы в беседе «${info.chatName}»!`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "bottom",
      });
      history.push("/chats");
    } catch (e) {
      toast({
        title: "Не получилось зайти",
        description: e.response?.data?.message,
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "bottom",
      });
      setJoining(false);
    }
  };

  if (!me) return null;

  return (
    <Box
      w="100%"
      minH="100vh"
      d="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Box
        bg="#FBF0D9"
        border="1px solid #E4D2A6"
        borderRadius="22px"
        boxShadow="0 30px 70px -24px rgba(36, 61, 39, 0.35)"
        p={8}
        maxW="380px"
        w="100%"
        textAlign="center"
        className="rise-in"
      >
        {error ? (
          <>
            <Text fontFamily="'Prata', serif" fontSize="22px" color="#243D27">
              Увы!
            </Text>
            <Text fontSize="sm" color="rgba(36,61,39,0.65)" mt={2} mb={5}>
              {error}
            </Text>
            <Button
              variant="outline"
              colorScheme="burgundy"
              onClick={() => history.push("/chats")}
            >
              К чатам
            </Button>
          </>
        ) : !info ? (
          <Spinner color="#8D414B" size="lg" my={8} />
        ) : (
          <>
            <Box
              w="64px"
              h="64px"
              borderRadius="full"
              bg="#243D27"
              d="flex"
              alignItems="center"
              justifyContent="center"
              mx="auto"
              mb={4}
            >
              <PaletteIcon size={30} color="#F2DFB6" />
            </Box>
            <Text fontFamily="'Prata', serif" fontSize="24px" color="#243D27">
              {info.chatName}
            </Text>
            <Text fontSize="sm" color="rgba(36,61,39,0.65)" mt={1}>
              {info.isPrivate ? (
                <>
                  <LockIcon boxSize="11px" mb="2px" /> закрытая беседа
                </>
              ) : (
                "открытая беседа"
              )}
              {" · "}участников: {info.usersCount}
              {info.groupAdmin ? ` · создатель: ${info.groupAdmin}` : ""}
            </Text>
            <Box d="flex" justifyContent="center" my={4}>
              <Ornament color="#8D414B" opacity={0.5} width={110} />
            </Box>
            {info.alreadyMember ? (
              <>
                <Text fontSize="sm" color="#243D27" mb={4}>
                  Вы уже участник этой беседы
                </Text>
                <Button
                  colorScheme="burgundy"
                  w="100%"
                  h="44px"
                  onClick={() => history.push("/chats")}
                >
                  Открыть чаты
                </Button>
              </>
            ) : (
              <Button
                colorScheme="burgundy"
                w="100%"
                h="44px"
                isLoading={joining}
                onClick={join}
                boxShadow="0 10px 24px -10px rgba(141, 65, 75, 0.55)"
                _hover={{ bg: "#7A3841", transform: "translateY(-1px)" }}
              >
                Зайти в беседу
              </Button>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default JoinPage;
